/**
 * Enum defining common actions that can be performed on table rows.
 *
 * These actions are used to track the state of rows in tables and lists,
 * particularly when managing row states with IListStateService implementations.
 */
export enum CommonRowActions {
    /**
     * Action for bulk operations on multiple rows
     */
    Bulk = "BULK",

    /**
     * Action for creating new rows
     */
    Create = "CREATE",

    /**
     * Action for updating existing rows
     */
    Update = "UPDATE",

    /**
     * Action for canceling operations on rows
     */
    Cancel = "CANCEL",

    /**
     * Action for selecting rows
     */
    Select = "SELECT",

    /**
     * Action for validating row data
     */
    Validate = "VALIDATE",

    /**
     * Action for deleting rows
     */
    Delete = "DELETE",

    /** Row highlighted without an accompanying create/update/delete. */
    Highlight = "HIGHLIGHT",

    /** Row failed an operation. */
    Error = "ERROR"
}
